import React, { useRef, useState } from "react";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

function SubmissionDialog({ title, content, onClose }) {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      PaperComponent={(props) => (
        <Paper {...props} sx={{ borderRadius: 2, padding: 4 }} />
      )}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

function SubmissionSuccessDialog({ onClose }) {
  return (
    <SubmissionDialog
      title="Thông tin đã được gửi"
      content="Cám ơn quý phụ huynh đã gửi thông tin. Chúng tôi sẽ liên lạc để sắp xếp khoá học cho bé."
      onClose={onClose}
    />
  );
}

function SubmissionFailureDialog({ onClose }) {
  return (
    <SubmissionDialog
      title="Thông tin chưa được gửi"
      content="Xin vui lòng thử lại."
      onClose={onClose}
    />
  );
}

function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [
    shouldShowSubmissionSuccessDialog,
    setShouldShowSubmissionSuccessDialog,
  ] = useState(false);
  const [
    shouldShowSubmissionFailureDialog,
    setShouldShowSubmissionFailureDialog,
  ] = useState(false);

  const formRef = useRef(null);

  const submitForm = (event) => {
    setIsSubmitting(true);

    const request = new XMLHttpRequest();

    request.open("POST", "https://api.web3forms.com/submit", true);
    request.onload = () => {
      formRef.current.reset();
      setIsSubmitting(false);
      setShouldShowSubmissionSuccessDialog(true);
    };
    request.onerror = () => {
      setIsSubmitting(false);
      setShouldShowSubmissionFailureDialog(true);
    };

    request.send(new FormData(event.target));

    event.preventDefault();
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ overflowX: "hidden" }}
      >
        <Card
          elevation={0}
          sx={{
            backgroundColor: "primary.light",
            borderRadius: 4,
            padding: "40px",
            width: 400,
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h4"
            color="common.white"
            align="center"
            gutterBottom
          >
            Trải nghiệm khoá học
          </Typography>

          <form ref={formRef} onSubmit={submitForm}>
            <input
              type="hidden"
              name="access_key"
              value="e779c209-fa88-4bea-bba2-2b23da0361e4"
            />
            <input type="hidden" name="subject" value="Trial submission form" />
            <input type="hidden" name="from_name" value="English Tree" />
            <input
              type="checkbox"
              name="botcheck"
              style={{ display: "none" }}
            />

            <CardContent>
              <Stack spacing={2}>
                <TextField
                  required
                  name="Child name"
                  placeholder="Họ và tên của bé"
                  sx={{ backgroundColor: "common.white", borderRadius: 1 }}
                  onInvalid={(event) =>
                    event.target.setCustomValidity("Vui lòng nhập thông tin.")
                  }
                  onInput={(event) => event.target.setCustomValidity("")}
                />
                <TextField
                  required
                  type="number"
                  name="Child age"
                  placeholder="Tuổi của bé"
                  sx={{ backgroundColor: "common.white", borderRadius: 1 }}
                  onInvalid={(event) =>
                    event.target.setCustomValidity("Vui lòng nhập số tuổi.")
                  }
                  onInput={(event) => event.target.setCustomValidity("")}
                />
                <TextField
                  required
                  type="email"
                  name="Parent email"
                  placeholder="Địa chỉ email của bạn"
                  sx={{ backgroundColor: "common.white", borderRadius: 1 }}
                  onInvalid={(event) =>
                    event.target.setCustomValidity("Vui lòng nhập email.")
                  }
                  onInput={(event) => event.target.setCustomValidity("")}
                />
                <TextField
                  required
                  type="tel"
                  name="Parent number"
                  placeholder="Số điện thoại của bạn"
                  sx={{ backgroundColor: "common.white", borderRadius: 1 }}
                  onInvalid={(event) =>
                    event.target.setCustomValidity(
                      "Vui lòng nhập số điện thoại.",
                    )
                  }
                  onInput={(event) => event.target.setCustomValidity("")}
                />
                <FormControl
                  sx={{ p: "14px", backgroundColor: "white", borderRadius: 1 }}
                >
                  <FormLabel>Khoá học</FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      name="English"
                      label="Tiếng Anh"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      name="Robotics"
                      label="Robotics"
                    />
                  </FormGroup>
                </FormControl>
              </Stack>
            </CardContent>

            <CardActions>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                padding="10px 10px 0px"
                width="100%"
              >
                {isSubmitting && <CircularProgress />}
                {!isSubmitting && (
                  <Button
                    variant="outlined"
                    size="large"
                    type="submit"
                    sx={{
                      color: "common.white",
                      borderColor: "common.white",
                      "&:hover": {
                        borderColor: "common.white",
                      },
                    }}
                  >
                    Gửi
                  </Button>
                )}
                <img
                  src="/images/try-out-course.png"
                  alt="try-out-course"
                  loading="lazy"
                  width={200}
                  style={{ borderRadius: 30, zIndex: 1 }}
                />
              </Stack>
            </CardActions>
          </form>
        </Card>
      </Stack>

      {shouldShowSubmissionSuccessDialog && (
        <SubmissionSuccessDialog
          onClose={() => setShouldShowSubmissionSuccessDialog(false)}
        />
      )}
      {shouldShowSubmissionFailureDialog && (
        <SubmissionFailureDialog
          onClose={() => setShouldShowSubmissionFailureDialog(false)}
        />
      )}
    </>
  );
}

export default ContactForm;
